import { render, staticRenderFns } from "./CreateNewEventModal.vue?vue&type=template&id=2fc23fe2&"
import script from "./CreateNewEventModal.vue?vue&type=script&lang=js&"
export * from "./CreateNewEventModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports